import React from 'react';
import AppointmentFirstStep from '../../pages/AppointmentForm/First-Reason';
import AppointmentSecondStep from '../../pages/AppointmentForm/Second-DateAndTime';
import AppointmentThirdStep from '../../pages/AppointmentForm/Third-ContactAndDetails';
import AppointmentFourthStep from '../../pages/AppointmentForm/Fourth-ConfirmAndBook';

const PAGES = {
    REASON: 0,
    DATE_AND_TIME: 1,
    CONTACT_AND_DETAILS: 2,
    CONFIRM_AND_BOOK: 3,
};

const appointmentFormDefaultValues = {
    reason: '',
    type: '',
    patientEmail: '',
    patientPhone: '',
    notificationPreferences: 0,
    appointmentNotes: '',
    consent: 1,
    translatorPreferredLanguage: '',
    translatorRequired: 0,
    startTime: '',
    endTime: '',
    timeSlot: {},
};

const appointmentSteps = [
    { title: 'Reason' },
    { title: 'Date & Time' },
    { title: 'Contact Details' },
    { title: 'Confirm & Book' },
];

/*

injection data for all validations, paging necessary to drive the Wizard.

*/

// It's not redux, but similar. These are Actions used with useReducer in Wizard.
const ACTIONS = {
    RESET: 'RESET',
    FINISHED_REASON: 'FINISHED_REASON',
    FINISHED_DATE_AND_TIME: 'FINISHED_DATE_AND_TIME',
    FINISHED_CONTACT_AND_DETAILS: 'FINISHED_CONTACT_AND_DETAILS',
    FINISHED_CONFIRM_AND_BOOK: 'FINISHED_CONFIRM_AND_BOOK',
    GOTO: 'GOTO',
};

// This stores the entire form data. React Hook Forms will pass this as argument in handleSubmit((here)=>{}).
const initialFormState = {
    ...appointmentFormDefaultValues,
    submitted: false,
    page: PAGES.REASON,
    isAppointmentForm: true,
};

// This gives the metadata of page component, and what actions to dispatch for going back / prev page.
const pageMetaData = {
    [PAGES.REASON]: {
        showProgressBar: true,
        component: AppointmentFirstStep,
        nextAction: ACTIONS.FINISHED_REASON,
        prevPage: PAGES.REASON,
    },
    [PAGES.DATE_AND_TIME]: {
        showProgressBar: true,
        component: AppointmentSecondStep,
        nextAction: ACTIONS.FINISHED_DATE_AND_TIME,
        prevPage: PAGES.REASON,
    },
    [PAGES.CONTACT_AND_DETAILS]: {
        showProgressBar: true,
        component: AppointmentThirdStep,
        nextAction: ACTIONS.FINISHED_CONTACT_AND_DETAILS,
        prevPage: PAGES.DATE_AND_TIME,
    },
    [PAGES.CONFIRM_AND_BOOK]: {
        showProgressBar: true,
        component: AppointmentFourthStep,
        nextAction: ACTIONS.FINISHED_CONFIRM_AND_BOOK,
        prevPage: PAGES.CONTACT_AND_DETAILS,
    },
};

// Reducer, exactly like how redux work. Actions will affect the state of the initialState data.
const reducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.RESET:
            return initialFormState;

        case ACTIONS.FINISHED_REASON:
            return {
                ...state,
                ...action.payload,
                page: PAGES.DATE_AND_TIME,
            };

        case ACTIONS.FINISHED_DATE_AND_TIME:
            return {
                ...state,
                ...action.payload,
                page: PAGES.CONTACT_AND_DETAILS,
            };

        case ACTIONS.FINISHED_CONTACT_AND_DETAILS:
            return {
                ...state,
                ...action.payload,
                page: PAGES.CONFIRM_AND_BOOK,
            };

        case ACTIONS.FINISHED_CONFIRM_AND_BOOK:
            return {
                ...state,
                submitted: true,
            };

        case ACTIONS.GOTO:
            return {
                ...state,
                page: action.payload.page,
                ...action.payload,
            };
        default:
            return state;
    }
};
export { initialFormState, ACTIONS, reducer, pageMetaData, appointmentSteps };
